import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import { CircularProgress } from "@mui/material";

interface LoadingButtonProps extends ButtonProps {
  loading: boolean;
  loadingIndicator?: React.ReactNode;
}

const LoadingButton = ({
  loading,
  loadingIndicator,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      {...props}
      disabled={loading || props.disabled}
      startIcon={
        loading ? (
          <CircularProgress color="inherit" size={16} />
        ) : (
          props.startIcon
        )
      }
    >
      {loading && loadingIndicator ? loadingIndicator : props.children}
    </Button>
  );
};

export default LoadingButton;
